import { ERROR_REQUEST_TIMEOUT } from '../modules/constants';
import { isEmpty, isString, isFunction } from '../modules/utils';
import { getMonitoringInstance } from '../interfaces/IMonitoring';
const requestTimeout = 10000;
export class AjaxException {
    constructor(exceptionStatus, exceptionText, exceptionMessage) {
        this.status = 0;
        this.statusText = null;
        this.message = null;
        this.rawResponse = null;
        this.status = exceptionStatus;
        this.statusText = exceptionText;
        if (exceptionMessage !== undefined) {
            this.message = exceptionMessage;
        }
    }
}
export class LegacyAjaxRequestClass {
    requestRawXHR(method, url, bodyParams, headers, successCallback, errorCallback, timeout) {
        const thisRequestTimeout = typeof timeout === 'number' ? timeout : requestTimeout;
        const xhr = new XMLHttpRequest();
        xhr.open(method, url, true);
        xhr.onload = () => {
            clearTimeout(requestTimer);
            requestTimer = 0;
            if (isFunction(successCallback)) {
                successCallback(xhr);
            }
        };
        xhr.onerror = () => {
            clearTimeout(requestTimer);
            requestTimer = 0;
            const failedURL = !isEmpty(url) ? url.split('?')[0] : url;
            let errorMessage = '';
            if (!isEmpty(xhr.statusText)) {
                errorMessage = xhr.statusText;
            }
            else {
                errorMessage = `Request to ${failedURL} failed on the network level`;
            }
            const monitoringContext = getMonitoringInstance();
            monitoringContext === null || monitoringContext === void 0 ? void 0 : monitoringContext.syncEvent("1", "SessionError", {
                ErrorCode: "NetworkRequestFailed",
                ErrorMessage: errorMessage
            });
            const error = new AjaxException(xhr.status, errorMessage);
            if (isFunction(errorCallback)) {
                errorCallback(error);
            }
            else {
                throw error;
            }
        };
        let requestTimer = setTimeout((closureURL) => {
            try {
                xhr.onreadystatechange = () => { };
                xhr.abort();
            }
            catch (err) { }
            const failedURL = !isEmpty(closureURL) ? closureURL.split('?')[0] : '';
            const monitoringContext = getMonitoringInstance();
            monitoringContext === null || monitoringContext === void 0 ? void 0 : monitoringContext.syncEvent("1", "NetworkTimeout", {
                OperationType: "MainNetworkTimeout",
                Description: 'Request timed out', RemoteURL: failedURL
            });
            const error = new AjaxException(-1, ERROR_REQUEST_TIMEOUT, ERROR_REQUEST_TIMEOUT);
            if (isFunction(errorCallback)) {
                errorCallback(error);
            }
            else {
                throw error;
            }
        }, thisRequestTimeout, url);
        let jsonEncoding = false;
        let hasContentType = false;
        if (!isEmpty(headers) && typeof headers === 'object') {
            Object.keys(headers).forEach(key => {
                if (key.toLowerCase() === 'content-type') {
                    hasContentType = true;
                    const value = headers[key];
                    if (isString(value)) {
                        if (value.toLowerCase().indexOf('json') !== -1) {
                            jsonEncoding = true;
                        }
                        else if (value.toLowerCase().indexOf('javascript') !== -1) {
                            jsonEncoding = true;
                        }
                    }
                }
                xhr.setRequestHeader(key, headers[key]);
            });
        }
        if (method === "POST" && !hasContentType) {
            xhr.setRequestHeader('Content-type', 'application/json');
            jsonEncoding = true;
        }
        let body = null;
        if (!isEmpty(bodyParams) && bodyParams.constructor === Object) {
            if (jsonEncoding) {
                body = JSON.stringify(bodyParams);
            }
            else {
                const dictionary = bodyParams;
                body = Object.keys(dictionary).map(key => {
                    return '\"' + encodeURIComponent(key) + '\"' + '=' + encodeURIComponent(dictionary[key]);
                }).join('&');
            }
        }
        else {
            body = bodyParams;
        }
        xhr.send(body);
    }
    request(method, url, bodyParams, headers, resolveCallback, rejectCallback, timeout) {
        const successProcessor = (xhr) => {
            var _a, _b;
            if (xhr.status >= 200 && xhr.status < 400) {
                if (isFunction(resolveCallback)) {
                    resolveCallback(xhr.responseXML || xhr.response || xhr.responseText, xhr);
                }
            }
            else {
                const failedURL = !isEmpty(url) ? url.split('?')[0] : url;
                const message = `Request to ${failedURL} failed with code ${xhr.status}`;
                const monitoringContext = getMonitoringInstance();
                monitoringContext === null || monitoringContext === void 0 ? void 0 : monitoringContext.syncEvent("1", "SessionError", {
                    ErrorCode: "NetworkRequestFailed",
                    ErrorMessage: message
                });
                const error = new AjaxException(xhr.status, xhr.statusText, message);
                error.rawResponse = (_b = (_a = xhr.responseXML) !== null && _a !== void 0 ? _a : xhr.response) !== null && _b !== void 0 ? _b : xhr.responseText;
                if (isFunction(rejectCallback)) {
                    rejectCallback(error);
                }
                else {
                    throw error;
                }
            }
        };
        this.requestRawXHR(method, url, bodyParams, headers, successProcessor, rejectCallback, timeout);
    }
    send(url, headers, resolveCallback, rejectCallback) {
        this.request("GET", url, undefined, headers, resolveCallback, rejectCallback);
    }
    post(url, params, headers, resolveCallback, rejectCallback) {
        this.request("POST", url, params, headers, resolveCallback, rejectCallback);
    }
}
export const HttpRequest = new LegacyAjaxRequestClass();
